import request from "@/plugins/axios"
//邮箱设置
let prefix = "eids-invoice/mailbox"

export function obtain(orgId) {
  return request({
    url: prefix + '/obtain/' + orgId,
    method: 'get',
  })
}

export function save(mailBoxInfo) {
  return request({
    url: prefix + '/server',
    method: 'post',
    data: mailBoxInfo,
  })
}

export function testconnection(mailBoxInfo) {
  return request({
    url: prefix + '/testconnection',
    method: 'post',
    data: mailBoxInfo,
  })
}


// 白名单
export function obtainWhitelist(orgId) {
  return request({
    url: prefix + '/whitelist/obtain/' + orgId,
    method: 'get',
  })
}

export function saveWhitelist(whitelistInfo) {
  return request({
    url: prefix + '/whitelist',
    method: 'post',
    data: whitelistInfo,
  })
}
// 自动邮箱设置
export function auto(orgId) {
  return request({
    url: prefix + '/server/auto/' + orgId,
    method: 'get',
  })
}
